import { render } from "./TeachersView.vue?vue&type=template&id=2ab98ca2&scoped=true"
import script from "./TeachersView.vue?vue&type=script&lang=js"
export * from "./TeachersView.vue?vue&type=script&lang=js"

import "./TeachersView.vue?vue&type=style&index=0&id=2ab98ca2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab98ca2"]])

export default __exports__